import { Modal } from '@trackman/web-shared-components';
import { ServiceTypes } from 'constants/ServiceTypes';
import { SessionMode } from 'enums/SessionMode';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { useInjection } from 'services/ioc/ioc.react';
import { FieldCalibrationStore } from 'stores/FieldCalibrationStore';
import { NotificationStore } from 'stores/NotificationStore';
import { SessionStore } from 'stores/SessionStore';
import WizardStore from 'stores/WizardStore';
import styled from 'styled-components';
import { buttonLightGrey, darkgrey } from 'styles/Colors';

const ModalContent = styled.div`
  padding: 24px;
  color: ${darkgrey};
  text-align: center;
  font-family: Lato;
  font-size: 15px;
  font-weight: 400;
  line-height: 21px;
`;

interface IProps {}

export const AbortModal: React.FC<IProps> = observer((props) => {
  const fieldCalibrationStore = useInjection<FieldCalibrationStore>(ServiceTypes.FieldCalibrationStore);
  const wizardStore = useInjection<WizardStore>(ServiceTypes.WizardStore);
  const sessionStore = useInjection<SessionStore>(ServiceTypes.SessionStore);
  const notificationStore = useInjection<NotificationStore>(ServiceTypes.NotificationStore);
  const history = useHistory();

  const onCloseHandler = () => {
    fieldCalibrationStore.setAbortModalVisible(false);
  };

  const onConfirmHandler = () => {
    sessionStore
      .setCurrentSessionMode({
        ...sessionStore.currentSessionMode,
        sessionMode: SessionMode.SessionEnded,
      })
      .then((isSuccess: boolean) => {
        if (!isSuccess) {
          notificationStore.addNotification({
            id: 'session-mode-error',
            message: 'Error while changing session mode',
            variant: 'error',
            removable: true,
            onClose: () => {
              notificationStore.removeNotification('session-mode-error');
            },
          });
        }
      })
      .finally(() => {
        wizardStore.reset();
        fieldCalibrationStore.reset();
        history.push('/');
      });
  };

  return (
    <Modal
      open={fieldCalibrationStore.abortModalVisible}
      title='Abort data capture'
      titleCenter
      onClose={onCloseHandler}
      confirmBtn={{
        onClick: onConfirmHandler,
        label: 'End',
        intent: 'warning',
      }}
      cancelBtn={{
        onClick: onCloseHandler,
        label: 'cancel',
        style: {
          backgroundColor: buttonLightGrey,
          color: darkgrey,
        },
      }}
      maxWidth={'xs'}
    >
      <ModalContent>
        <div>You are about to end the data capture before it is complete.</div>
        <div>Are you sure you want to proceed?</div>
      </ModalContent>
    </Modal>
  );
});
